import {
  Button,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Checkbox
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React, { useMemo, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { color } from "../../../../assets/const/color";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { useAssignment } from "../../../../Hooks/assignment";
import useCircular from "../../../../Hooks/circular";
import Loader from "../../../../common/Loader";
import useMyClass from "../../../../Hooks/myClass";
import useStaff from "../../../../Hooks/staff";
import { useStyles } from "./styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import * as Yup from "yup";
import useAuthStore from "../../../../Hooks/auth";
import useCourse from "../../../../Hooks/course";
import { yearList } from "../../Migration/fillter";

const assignmentSchema = Yup.object().shape({
  idFaculty: Yup.string().required("* Please select faculty"),
  idClass: Yup.string().required("* Please select subject"),
  classDate: Yup.string().required("* Please enter assignment date"),
  typeOfAssignment: Yup.string().required("* Please enter type of assignment"),
  description: Yup.string().required("* Please enter description"),
  email: Yup.string().required("* Please enter email"),
  department: Yup.string().required("* Please select department"),
  idYear: Yup.string().required("* Please select year"),
  // studentName: Yup.string().required("* Please select the students"),
});

const AddEditAssignment = () => {
  const classes = useStyles();
  const [state, setState] = useState([]);
  const [idStudent, setIdStudent] = useState({ studentIDS: [] });
  const [studentName, setStudentName] = useState([]);

  const { searchStaffService, staffData } = useStaff();
  const { departmentData, getDepartmentAction } = useCourse();

  const { userId, institutionId } = useAuthStore();

  const {
    addAssignmentAction,
    currentAssignment,
    updatedAssignmentAction,
    redirect,
    getClassesAction,
    classData,
    loading,
  } = useAssignment();
  const {
    studentsByIdAction,
    getStudentsID,
  } = useCircular();

  const navigate = useNavigate();

  React.useEffect(() => {
    const abortController = new AbortController();
    let staffSearch = {
      idDepartment: "",
      regNumber: "",
      sortBy: "asc",
      orderBy: "created_at",
      limit: 10,
      offSet: 0,
    };

    searchStaffService({ data: staffSearch, signal: abortController.signal });
    return () => {
      abortController.abort();
    };
  }, []);

  React.useEffect(() => {
    if (redirect) {
      navigate("/assignment");
    }
  }, [redirect]);

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  React.useEffect(() => {
    getClassesAction({ idFaculty: userId, limit: 10, offset: 0 });
  }, []);

  //  Student start
  
  const handleSelectStudentFocus = (event) => {
    const {
      target: { value },
    } = event;
    setState(
      // On autofill we get a stringified value.
      typeof value === "string" ? value?.split(",") : value
    );
  };

  const handleStudentSelectAll = (event) => {
    if (event.target.checked) {
      let customer_names = getStudentsID?.map((ele) => ele?.name)
      let selectCustomer_id = [];
      getStudentsID?.map((ele) => {
        selectCustomer_id?.push({ id: ele?.id })
      })
      setStudentName(customer_names)
      setIdStudent({ studentIDS: selectCustomer_id })
    }
    else {
      setStudentName([])
      setIdStudent({ studentIDS: [] })
    }
  }

  const handleSelectStudent = (event, data) => {
    if (idStudent?.studentIDS?.some((item) => item?.id == data?.id)) {
      setIdStudent({ ...idStudent, studentIDS: idStudent?.studentIDS?.filter((item) => item?.id !== data?.id) })
    } else {
      setIdStudent({ ...idStudent, studentIDS: [...idStudent?.studentIDS, { id: data?.id }] })
    }
    if (studentName?.includes(data.name)) {
      setStudentName(studentName?.filter((item) => item !== data?.name))
    } else {
      setStudentName([...studentName, data?.name])
    }
  };

  const [getYear, setGetYear] = useState('');
  const [getDept, setGetDept] = useState('');
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => { 
    if (getYear && getDept) {
      studentsByIdAction({
        currentYear: getYear,
        DepartmentID: getDept,
        institutionId: institutionId
      })
      setStudentName([]);
      setIdStudent({ studentIDS: [] });
    }
  }, [getYear, getDept])
 
  const handleYear = (e) => {
    setGetYear(e.target.value);
  }
  const handleDept = (e) => {
    setGetDept(e.target.value);
  }

//  Student end

  const initialValue = {
    idFaculty: userId || "",
    idClass: currentAssignment?.idClass || "",
    classDate: currentAssignment?.classDate || "",
    typeOfAssignment: currentAssignment?.typeOfAssignment || "",
    description: currentAssignment?.description || "",
    email: currentAssignment?.email || "",
    department: currentAssignment?.idDepartment || "",
    // targetAudienceYear: currentAssignment?.idTarget || "",  
    idYear: currentAssignment?.year || "",
    // idStudent : currentAssignment?.idStudents || "",
  };
  useEffect(() => { 
    if (getStudentsID) {
      if(currentAssignment?.idStudents){
      let studentListIDS = currentAssignment?.idStudents.map((ele) => ({ id: ele.id }))
      setIdStudent({ studentIDS: studentListIDS })
      const commonIds = currentAssignment?.idStudents
        ?.filter(item1 => getStudentsID?.some(item2 => item2?.id === item1?.id))
        ?.map(commonItem => {
          const correspondingItem = getStudentsID?.find(item => item?.id === commonItem?.id);
          return correspondingItem?.name;
        });
        setStudentName(commonIds)
      }
    }
     
  }, [getStudentsID])

 console.log("currentAssignment", currentAssignment)
  console.log("currentAssignment student data", currentAssignment?.idStudents)
  
  console.log("idStudent", idStudent, "studentName", studentName)
  const modifiedClassData = useMemo(() => {
    if (classData) {
      const classDataWithUniqueSubjectName = classData?.map((d) => ({
        name: d.name,
        id: d.id,
      }));
      return [
        ...new Map(
          classDataWithUniqueSubjectName.map((item) => [item["name"], item])
        ).values(),
      ];
    } else {
      return [];
    }
  }, [classData]);
  console.log(modifiedClassData, "ID");
  const studentValid = (values) => {
    const errors = {};
    if (studentName?.length === 0) {
      errors.studentName = "* Please select the student"
    }
    setFormErrors(errors)
    if (Object.keys(errors).length === 0) {
      addAssignmentAction({
        idFaculty: userId,
        idClass: values.idClass,
        classDate: values.classDate,
        typeOfAssignment: values.typeOfAssignment,
        description: values.description,
        email: values.email,
        idDepartment: values.department,
        year: values.idYear,
        institutionId: institutionId,
        idStudents: idStudent.studentIDS,
      });
    }
  }
  const studentUpdateValid = (values) => {
    const errors = {};
    if (studentName?.length === 0) {
      errors.studentName = "* Please select the student"
    }
    setFormErrors(errors)
    if (Object.keys(errors).length === 0) {
      updatedAssignmentAction({
        id: currentAssignment.id,
        idFaculty: userId,
        idClass: values.idClass,
        classDate: values.classDate,
        typeOfAssignment: values.typeOfAssignment,
        description: values.description,
        email: values.email,
        idDepartment: values.department,
        year: values.idYear,
        idStudents: idStudent.studentIDS,
      });
    }
  }
  return (
    <React.Fragment>
      {loading && <Loader />}
      <Stack className={classes.root}>
        <Stack
          sx={{
            pb: 3,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            "& .MuiButton-root:hover": {
              background: `${color.lightGreen} !important`,
              color: `${color.white} !important`,
            },
          }}
        >
          <ArrowBackIosIcon
            role="button"
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/assignment")}
          />
          <Typography
            sx={{
              fontFamily: "inter",
              fontSize: "18px !important",
              fontWeight: "700 !important",
              color: "#00473E",
            }}
          >
            {currentAssignment !== null
              ? "Update Assignment"
              : "Add Assignment"}
          </Typography>
        </Stack>
        <Stack className={classes.form_container}>
          <Formik
            initialValues={initialValue}
            validationSchema={assignmentSchema}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={(values) => {
              if (currentAssignment !== null) {
                studentUpdateValid(values)
              } else {
                studentValid(values)  
                
              }
            }}
          >
            {(formik) => {
              const {
                errors,
                touched,
                handleChange,
                handleBlur,
                values,
                handleSubmit,
              } = formik;
              return (
                <>
                  <form onSubmit={handleSubmit}>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>
                        Department
                      </Typography>

                      <Stack>
                        <Select
                          id="department"
                          name="department"
                          className={
                            errors.idFaculty && touched.idFaculty
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          value={values.department}
                          onChange={(e) => {
                              handleChange(e); 
                              handleDept(e);
                            }}
                          placeholder="what's your favourite car?"
                          IconComponent={CustomExpandMore}
                          sx={{
                            width: "230px",
                            display: "flex",
                          }}
                          displayEmpty
                        >
                          <MenuItem disabled value="">
                            <span>Select Department</span>
                          </MenuItem>
                          {typeof departmentData !== "undefined"
                            ? departmentData.map((_el) => (
                              <MenuItem value={_el.id || ""}>
                                {_el.name}
                              </MenuItem>
                            ))
                            : null}
                        </Select>
                        <ErrorMessage
                          name="department"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>
                        Select subject
                      </Typography>
                      <Stack>
                        <Select
                          id="idClass"
                          name="idClass"
                          placeholder="Select subject"
                          IconComponent={CustomExpandMore}
                          displayEmpty
                          sx={{
                            width: "230px",
                            display: "flex",
                          }}
                          className={
                            errors.idClass && touched.idClass
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => handleChange(e)}
                          value={values.idClass}
                        >
                          <MenuItem value="" disabled>
                            Select subject
                          </MenuItem>
                          {modifiedClassData?.length > 0 &&
                            modifiedClassData?.map((_el, index) => (
                              <MenuItem value={_el.id} key={index}>
                                {`${_el.name}`}
                              </MenuItem>
                            ))}
                        </Select>
                        <ErrorMessage
                          name="idClass"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>
                        Year
                      </Typography>
                      <Stack>
                        <Select
                          id="idYear"
                          name="idYear"
                          IconComponent={CustomExpandMore}
                          defaultValue="Select Year"
                          onChange={(e) => {
                            handleChange(e); 
                            handleYear(e);
                          }}
                          sx={{
                            width: "230px",
                            display: "flex",
                            "& .MuiSelect-select .notranslate::after":
                              "Select a filter"
                                ? { content: `"Select Year"`, opacity: 1 }
                                : {},
                          }}
                          value={values.idYear}
                          displayEmpty
                        >
                          <MenuItem value="" disabled>
                            Select Year
                          </MenuItem>
                          {yearList && yearList?.map((_el, index) => (
                            <MenuItem value={_el.value} key={index}>
                              {_el.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <ErrorMessage
                          name="idYear"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>

                    <Stack sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}>
                      <Typography className={classes.label}>
                        Student
                      </Typography>
                      <Stack>
                        <Select
                          disabled={values.idYear === "" || values.department === "" ? true : false}
                          id="studentName"
                          name="studentName"
                          multiple
                          placeholder="Choose Organization"
                          IconComponent={CustomExpandMore}
                          defaultValue="Select Student"
                          displayEmpty
                          value={studentName}
                          onFocus={handleSelectStudentFocus}
                          renderValue={(selected) => selected?.join(', ')}
                          sx={{
                            width: "230px",
                            display: "flex",
                            "& .MuiSelect-select .notranslate::after":
                              "Select a filter"
                                ? { content: `"Select Student"`, opacity: 1 }
                                : {},
                          }}
                        >
                          <MenuItem value="" disabled>Select Student</MenuItem>
                          {getStudentsID?.length > 1 ?
                            <label htmlFor="studentAll">
                              <div style={{ padding: "6px 16px", cursor: "pointer" }} onChange={(event) => handleStudentSelectAll(event)}>
                                <Checkbox id="studentAll" checked={idStudent?.studentIDS?.length === getStudentsID?.length} />Select All
                              </div>
                            </label> : ""}
                          {getStudentsID &&
                            getStudentsID?.map((_el, index) => (
                              <div key={_el?.id} style={{ padding: "6px 16px", cursor: "pointer" }}
                                onClick={(event) => handleSelectStudent(event, _el)}
                              >
                                <Checkbox checked={studentName?.includes(_el?.name)} />{_el?.name}
                              </div>
                            ))}
                        </Select> 
                        <span className={classes.error}>
                          {formErrors.studentName}
                        </span>
                        </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>
                        Date of assignment
                      </Typography>
                      <Stack>
                        <TextField
                          id="classDate"
                          type="date"
                          name="classDate"
                          sx={{
                            width: "230px",
                            display: "flex",
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            errors.classDate && touched.classDate
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          placeholder="Enter assignment date"
                          onChange={handleChange}
                          value={values && values.classDate}
                        />
                        <ErrorMessage
                          name="classDate"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>
                        Type of assignment
                      </Typography>
                      <Stack>
                        <TextField
                          id="typeOfAssignment"
                          name="typeOfAssignment"
                          sx={{
                            width: "230px",
                            display: "flex",
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            errors.typeOfAssignment && touched.typeOfAssignment
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          placeholder="Enter type of assignment"
                          onChange={handleChange}
                          value={values && values.typeOfAssignment}
                        />
                        <ErrorMessage
                          name="typeOfAssignment"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>
                        Description
                      </Typography>
                      <Stack>
                        <TextField
                          id="description"
                          name="description"
                          sx={{
                            width: "230px",
                            display: "flex",
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            errors.description && touched.description
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          placeholder="Enter description"
                          onChange={handleChange}
                          value={values && values.description}
                        />
                        <ErrorMessage
                          name="description"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <Typography className={classes.label}>Email</Typography>
                      <Stack>
                        <TextField
                          id="email"
                          name="email"
                          sx={{
                            width: "230px",
                            display: "flex",
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          className={
                            errors.email && touched.email
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          placeholder="Enter email"
                          onChange={handleChange}
                          value={values && values.email}
                        />
                        <ErrorMessage
                          name="email"
                          component="span"
                          className={classes.error}
                        />
                      </Stack>
                    </Stack>
                    <Button className={classes.greenBtn} type="submit">
                      {currentAssignment !== null ? "Update" : "Add"}
                    </Button>
                  </form>
                </>
              );
            }}
          </Formik>
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default AddEditAssignment;
